import $ from 'jquery';
import Emitter from './emitter';
import { redraw } from './drawing';

/**
 * Map of transition types.
 */
export const transitionTypes = {

    css: {

        init(toggler) {
            toggler.$element[0].addEventListener('transitionend', function(e) {
                if (e.target === toggler.$element[0]) {
                    toggler.transitionEnd();
                }
            });
        },
    },

    height: {

        init(toggler) {
            toggler.$element.css('display', toggler.isOpen ? '' : 'none');
        },

        start(toggler) {
            if (toggler.isOpen) {
                toggler.$element.slideDown(300, () => toggler.transitionEnd());
            } else {
                toggler.$element.slideUp(300, () => toggler.transitionEnd());
            }
        },

        skip(toggler) {
            toggler.$element.css('display', toggler.isOpen ? '' : 'none');
        },
    },
};

/**
 * Toggler class for toggling the visual state of an element.
 */
export default class Toggler extends Emitter {

    /**
     *
     * @param element
     * @param settings
     */
    constructor(element, settings={}) {
        super();

        this.$element = $(element);
        this.isOpen = (typeof settings.open === 'boolean') ? settings.open : true;
        this.transition = (settings.transition in transitionTypes) ? settings.transition : false;

        this.transitionInit();
    }

    /**
     *
     * @param isOpen
     * @param transition
     */
    toggle(isOpen, transition) {
        isOpen = (typeof isOpen === 'boolean') ? isOpen : !this.isOpen;
        transition = (typeof transition === 'boolean') ? transition : true;

        if (this.isOpen !== isOpen) {
            this.isOpen = isOpen;

            if (this.transition && transition) {

                this.transitionStart();

            } else {

                this.$element
                    .removeClass('is-before-opening is-opening is-before-closing is-closing')
                    .toggleClass('is-open', this.isOpen)
                    .toggleClass('is-closed', !this.isOpen);

                this.transitionSkip();
            }

            this.trigger('toggle');
            this.trigger(this.isOpen ? 'open' : 'close');
        }
    }

    /**
     *
     * @param transition
     */
    open(transition) {
        this.toggle(true, transition);
    }

    /**
     *
     * @param transition
     */
    close(transition) {
        this.toggle(false, transition);
    }

    /**
     *
     */
    transitionInit() {
        this.$element
            .removeClass('is-before-opening is-opening is-before-closing is-closing')
            .toggleClass('is-open', this.isOpen)
            .toggleClass('is-closed', !this.isOpen);

        const transitionType = transitionTypes[this.transition];
        if (transitionType && transitionType.init) {
            transitionType.init(this);
        }
    }

    /**
     *
     */
    transitionStart() {

        if (this.isOpen) {

            if (this.$element.hasClass('is-before-closing')) {

                this.$element
                    .removeClass('is-before-closing')
                    .addClass('is-open')

            } else if (this.$element.hasClass('is-closing')) {

                this.$element
                    .removeClass('is-before-closing is-closing')
                    .addClass('is-opening')

            } else {

                this.$element
                    .removeClass('is-closed')
                    .addClass('is-before-opening');

                redraw(this.$element);

                this.$element
                    .removeClass('is-before-opening')
                    .addClass('is-opening');
            }

        } else {

            if (this.$element.hasClass('is-before-opening')) {

                this.$element
                    .removeClass('is-before-opening')
                    .addClass('is-closed')

            } else if (this.$element.hasClass('is-opening')) {

                this.$element
                    .removeClass('is-opening')
                    .addClass('is-closing')

            } else {

                this.$element
                    .removeClass('is-open')
                    .addClass('is-before-closing');

                redraw(this.$element);

                this.$element
                    .removeClass('is-before-closing')
                    .addClass('is-closing');
            }
        }

        const transitionType = transitionTypes[this.transition];
        if (transitionType && transitionType.start) {
            transitionType.start(this);
        }

        this.trigger('transitionStart');
    }

    /**
     *
     */
    transitionEnd() {
        if (this.isOpen) {

            this.$element
                .removeClass('is-opening')
                .addClass('is-open');

        } else {

            this.$element
                .removeClass('is-closing')
                .addClass('is-closed');
        }

        const transitionType = transitionTypes[this.transition];
        if (transitionType && transitionType.end) {
            transitionType.end(this);
        }

        this.trigger('transitionEnd');
    }

    /**
     *
     */
    transitionSkip() {
        const transitionType = transitionTypes[this.transition];
        if (transitionType && transitionType.skip) {
            transitionType.skip(this);
        }
    }
}



// WEBPACK FOOTER //
// ./source/scripts/utils/toggler.js